import React from "react";
import PropTypes from "prop-types";

import { Graphics } from "./components/Graphics";

import "./style.scss";

export class Timer extends React.Component {
  componentWillMount() {
    this.props.createTimer({
      props: this.props.defaultProps,
    });
  }

  render() {
    return (
      <ul>
        <li
          id={"Timer_"+this.props.id}
          className={'Timer'}>
          <p aria-hidden="true" className="label">{this.props.type}</p>
          <Graphics id={this.props.id} />
        </li>
      </ul>
    );
  }
}

Timer.propTypes = {
  createTimer: PropTypes.func,
};

Timer.defaultProps = {};
